module.exports = __webpack_public_path__ + "7736fb73.svg";